module.exports = __webpack_public_path__ + "b85eaf6d6985e1d120380c1eb41be886.svg";